import React, { createContext, useContext } from 'react'
import type { UseAddressBook } from '@/user/address-book/hooks/use-address-book'
import { useAddressBook } from '@/user/address-book/hooks/use-address-book'

export type AddressBookContextProps = UseAddressBook

export const AddressBookContext = createContext<AddressBookContextProps>(
  {} as never as AddressBookContextProps // It's ok that initial state is empty
)

type AddressBookProviderProps = {
  children: React.ReactNode
}

export const AddressBookProvider: React.FC<AddressBookProviderProps> = ({ children }) => {
  const addressBookData: ReturnType<typeof useAddressBook> = useAddressBook()

  // Please do not add any logic here, this context just stores data

  return (
    <AddressBookContext.Provider value={addressBookData}>{children}</AddressBookContext.Provider>
  )
}

export const useAddressBookContext = () => useContext(AddressBookContext)
